<template>
  <div class="autocomplete">
    <v-autocomplete
      v-model="citiesIds"
      @keyup="search"
      @change="handleSelect"
      :multiple="multiple"
      :items="cities"
      :label="$t('city.label.city')"
      :no-data-text="$t('city.noData')"
      prepend-inner-icon="mdi-magnify"
      item-value="id"
      item-text="name"
      clearable
      outlined
      dense
    />

    <v-progress-circular
      v-show="isCitiesLoading"
      class="autocomplete-loading"
      color="primary"
      width="2"
      size="15"
      indeterminate
    />
  </div>
</template>

<script>
import store from '@/store'
import { mapMutations } from 'vuex'
import { fetchCitiesPaginated } from '@/services/city/cityService'

export default {
  name: 'HCitySelect',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'citiesIds',
    },

    countryCode: {
      type: String,
      default: null,
    },

    stateId: {
      type: [String, Number],
      default: null,
    },
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    handleSelect(value) {
      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        Promise.resolve(this.setFilters({ ...store.getters.filters, ...{ [this.type]: value }}))
          .then(() => this.setCurrentPage(1))
          .then(() => this.fetchData())
      }, 500)
    },

    search({ target }) {
      const term = target?.value
      if (!term && term?.length <= 3) return

      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.isCitiesLoading = true

        fetchCitiesPaginated({ search: term, countryCode: this.countryCode, stateId: this.stateId })
          .then(({ data }) => this.cities = data?.result)
          .catch(({ data }) => this.$store.dispatch('showErrorMessage', data.message))
          .finally(() => this.isCitiesLoading = false)
      }, 1000)
    },
  },

  data() {
    return {
      citiesIds: [],
      cities: [],
      selectedCities: [],
      isCitiesLoading: false,
      timer: null,
    }
  }
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-loading {
  position: absolute;
  top: 20px;
  right: 63px;
  transform: translateY(-50%);
}
</style>
